import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import Modal from "react-modal";
import {useForm} from "react-hook-form";
import {
    EditFormDropdownInputField,
    EditFormMultiTextInputField,
    EditFormTextInputField,
    FormControls
} from "../../Components/ReactTable/EditRecordForm";
import {useServiceBase} from "../../Components/ReactTable/useServiceBase";
import {setValuesToNullIfEmptyOrUndefined, toTitleCase} from "../../Components/ReactTable/helpers";
import _ from "lodash";
import date from "lodash";
import {faIcons} from "../../../utils/iconConstants";
import {INDEX_FIELD} from "../../Components/ReactTable/common_custom_columns";

const MerchantDetailsModal = ({data, refreshData, brandOnboardingDecode}) => {
    const endpointUrlForPost = `${process.env.REACT_APP_EDP_API_BASE_URL}/mapEnforcementMerchantClients/`;
    const {onRowEditConfirmed} = useServiceBase({endpointUrlForPost});

    const [isOpen, updateIsOpen] = useState(false);

    const merchantDetailsForm = useForm();


    useEffect(() => {
        const dataCloned = _.cloneDeep(data);
        const clientDashboardSpecificFields = ["fba_count", "promo_count", "price_count", "violations"]
        clientDashboardSpecificFields.forEach(field => delete dataCloned[field])
        merchantDetailsForm.reset(dataCloned)
    }, []);

    const updateMerchantDetails = async updatedData => {
        try {
            await onRowEditConfirmed(setValuesToNullIfEmptyOrUndefined(updatedData))
                .then(() => {
                    updateIsOpen(false);
                    refreshData(date.now());
                });
        } catch (e) {
            console.error("Error updating merchant details: ", e);
            merchantDetailsForm.setError('apiError', {type: 'server', message: e.message});
        }
    };

    const editFields = [
        INDEX_FIELD,
        {id: "merchant_brand_id", Component: args => <EditFormDropdownInputField  {...args} options={brandOnboardingDecode} disabled label={"Merchant Brand"}/>},
        {id: "merchant_id", Component: args => <EditFormTextInputField  {...args} disabled/>},
        {id: "merchant_name", Component: args => <EditFormTextInputField  {...args} disabled/>},
        {id: "business_name", Component: args => <EditFormTextInputField  {...args}  />},
        {id: "contact_name", Component: args => <EditFormTextInputField {...args}  />},
        {id: "contact_phone", Component: args => <EditFormTextInputField  {...args}  />},
        {id: "contact_email", Component: args => <EditFormTextInputField  {...args}  />},
        {id: "address", Component: args => <EditFormTextInputField  {...args}  />},
        {id: "notes", Component: args => <EditFormMultiTextInputField  {...args} label={"Notes"}/>}
    ]

    return (
        <div className={'merchant-details-modal-container'}>
            <button className="hollow button secondary merchant-details-edit-button"
                    type="button"
                    name="close"
                    title={'Edit Merchant Details'}
                    onClick={() => updateIsOpen(true)}
                    data-testid={'merchant-details-modal-button'}
            >
                <i data-testid={'merchant-details-edit-button-icon'}
                   className={faIcons.edit}/>
            </button>

            <Modal
                clickable
                isOpen={isOpen}
                className="react-table-edit-modal edit-modal-merchant-details-modal"
                overlayClassName="Overlay"
                ariaHideApp={false}
                onRequestClose={() => updateIsOpen(false)}
            >
                <div><h5 className={"modal-header-text"}>{`Edit Merchant Details`}</h5></div>
                <div className={"edit-modal-data-row"} data-testid={'merchant-details-modal'}>
                    <form onSubmit={merchantDetailsForm.handleSubmit(updateMerchantDetails)} role={'form'}
                          className={'edit-form'}>
                        {
                            editFields
                                .map(({id, Component}) => {
                                    return <div className={`edit-form-row edit-row-${id}`} key={id}>
                                        <Component
                                            key={id}
                                            id={id}
                                            form={merchantDetailsForm}
                                            label={toTitleCase(id)}
                                        />
                                    </div>
                                })
                        }
                        <FormControls onClick={() => updateIsOpen(!isOpen)} form={merchantDetailsForm}/>
                    </form>
                </div>
            </Modal>
        </div>
    );
};

MerchantDetailsModal.propTypes = {
    brandOnboardingDecode: PropTypes.array.isRequired,
    data: PropTypes.object.isRequired,
    refreshData: PropTypes.func.isRequired
};

export default MerchantDetailsModal;